import { APP_BASE_HREF } from '@angular/common';
import { Provider } from '@angular/core';
import { environment } from '@esp-enrollment-form/shared-utils';

import { APP_INPUT_BASEHREF, APP_SELECTOR } from '../app.config-constants';

const setupBaseHref = () =>
  document.querySelector(APP_SELECTOR)?.getAttribute(APP_INPUT_BASEHREF) ||
  environment.baseHref;

export function provideBaseHref() {
  const providers: Provider[] = [
    {
      provide: APP_BASE_HREF,
      useFactory: () => setupBaseHref(),
    },
  ];

  return providers;
}
